import React from "react";
import useIsMobile from "../../common/hooks/useIsMobile";

function Icon() {
  const isMobile = useIsMobile()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={!isMobile ? "10vw": "36vw"}
      height={!isMobile ? "10vw": "36vw"}
      fill="none"
      viewBox="0 0 196 160"
    >
      <mask id="path-1-inside-1_199_498" fill="#fff">
        <path d="M187.091 26.667v-8.89h-8.909V8.89h-8.909V0h-53.455v8.889h-8.909v8.889H89.091v-8.89h-8.91V0H26.728v8.889h-8.909v8.889H8.91v8.889H0V71.11h8.91V80h8.908v8.889h8.91v8.889h8.908v8.889h8.91v8.889h8.909v8.888h8.909v8.889h8.909v8.889h8.909v8.889h8.909V160h17.818v-8.889h8.909v-8.889h8.909v-8.889h8.909v-8.889h8.909v-8.888h8.91v-8.889h8.909v-8.89h8.909V88.89h8.909V80h8.909v-8.889H196V26.667h-8.909zm-17.818 35.555v8.89h-8.909V80h-8.909v8.889h-8.91v8.889h-8.909v8.889h-8.909v8.889h-8.909v8.888h-8.909v8.889H89.091v-8.889h-8.91v-8.888h-8.908v-8.889h-8.91v-8.89h-8.908V88.89h-8.91V80h-8.909v-8.889h-8.909v-8.889h-8.909V35.556h8.91v-8.89h8.908v-8.888h35.637v8.889h8.909v8.889h8.909v8.888h17.818v-8.888h8.909v-8.89h8.909v-8.888h35.637v8.889h8.909v8.889h8.909v26.666h-8.909z"></path>
      </mask>
      <path
        stroke="#575757"
        strokeWidth="4"
        d="M187.091 26.667v-8.89h-8.909V8.89h-8.909V0h-53.455v8.889h-8.909v8.889H89.091v-8.89h-8.91V0H26.728v8.889h-8.909v8.889H8.91v8.889H0V71.11h8.91V80h8.908v8.889h8.91v8.889h8.908v8.889h8.91v8.889h8.909v8.888h8.909v8.889h8.909v8.889h8.909v8.889h8.909V160h17.818v-8.889h8.909v-8.889h8.909v-8.889h8.909v-8.889h8.909v-8.888h8.91v-8.889h8.909v-8.89h8.909V88.89h8.909V80h8.909v-8.889H196V26.667h-8.909zm-17.818 35.555v8.89h-8.909V80h-8.909v8.889h-8.91v8.889h-8.909v8.889h-8.909v8.889h-8.909v8.888h-8.909v8.889H89.091v-8.889h-8.91v-8.888h-8.908v-8.889h-8.91v-8.89h-8.908V88.89h-8.91V80h-8.909v-8.889h-8.909v-8.889h-8.909V35.556h8.91v-8.89h8.908v-8.888h35.637v8.889h8.909v8.889h8.909v8.888h17.818v-8.888h8.909v-8.89h8.909v-8.888h35.637v8.889h8.909v8.889h8.909v26.666h-8.909z"
        mask="url(#path-1-inside-1_199_498)"
      ></path>
    </svg>
  );
}

export default Icon;
